import { ShaderMaterialParameters } from 'three';

import { extend, MaterialNode } from '@react-three/fiber';
import {
  MeshOutlineMaterial,
  MeshOutlineMaterialParameter,
  MeshUVMaterial,
} from '@spazious/dollhouse-three';

extend({ MeshUVMaterial, MeshOutlineMaterial });

declare global {
  namespace JSX {
    interface IntrinsicElements {
      meshUVMaterial: MaterialNode<MeshUVMaterial, [ShaderMaterialParameters]>;
      meshOutlineMaterial: MaterialNode<MeshOutlineMaterial, [MeshOutlineMaterialParameter]>;
    }
  }
}
